import { buildStatusOptions } from '@/shared/constants/statusOptions';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { BuildStatus } from '@flowqa/shared';

export type PipelineCloneStatus = BuildStatus | 'none';
export type CloneSortDirection = 'asc' | 'desc';
export type CloneSortKey =
  | 'name'
  | 'latestBuildTimestamp'
  | 'metrics.passRate'
  | 'metrics.passRateDelta'
  | 'metrics.frequencyPerDay'
  | 'metrics.frequencyPerDayDelta'
  | 'metrics.averageDurationMs'
  | 'metrics.averageDurationMsDelta';

export const cloneDefaultSortKey: CloneSortKey = 'latestBuildTimestamp';
export const cloneDefaultSortDirection: CloneSortDirection = 'desc';

export const cloneSortOptions: Array<{ key: CloneSortKey; label: string }> = [
  { key: 'name', label: 'Pipeline Name' },
  { key: 'latestBuildTimestamp', label: 'Latest' },
  { key: 'metrics.passRate', label: 'Pass Rate' },
  { key: 'metrics.passRateDelta', label: 'Pass Rate Delta' },
  { key: 'metrics.frequencyPerDay', label: 'Frequency' },
  { key: 'metrics.frequencyPerDayDelta', label: 'Frequency Delta' },
  { key: 'metrics.averageDurationMs', label: 'Avg. Duration' },
  { key: 'metrics.averageDurationMsDelta', label: 'Avg. Duration Delta' },
];

export const cloneSortFieldMap: Record<CloneSortKey, string> = {
  name: 'name',
  latestBuildTimestamp: 'latestBuildTimestamp',
  'metrics.passRate': 'executionPassRate',
  'metrics.passRateDelta': 'executionPassRateDelta',
  'metrics.frequencyPerDay': 'executionFrequencyPerDay',
  'metrics.frequencyPerDayDelta': 'executionFrequencyPerDayDelta',
  'metrics.averageDurationMs': 'executionAverageDurationMs',
  'metrics.averageDurationMsDelta': 'executionAverageDurationMsDelta',
};

export const cloneColumnOptions: Array<{ field: string; label: string; mandatory?: boolean }> = [
  { field: 'name', label: 'Pipeline', mandatory: true },
  { field: 'latestBuildStatus', label: 'Latest' },
  { field: 'metrics.passRate', label: 'Pass Rate' },
  { field: 'metrics.frequencyPerDay', label: 'Frequency' },
  { field: 'metrics.averageDurationMs', label: 'Average Duration' },
  { field: 'tags', label: 'Tags' },
  { field: 'actions', label: 'Actions' },
];

export const cloneStatusOptions: Array<{ value: PipelineCloneStatus; label: string }> = [
  ...buildStatusOptions,
  { value: 'none', label: 'No Builds' },
];

export const cloneDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  latestBuildStatus: true,
  latestBuildTimestamp: false,
  'metrics.passRate': true,
  'metrics.frequencyPerDay': true,
  'metrics.averageDurationMs': true,
  tags: false,
  actions: true,
};
